exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.permission-group{border:1px solid #ccc;border-radius:6px;position:relative}.group-name{position:absolute;top:-10px;left:5px;background:#fff;font-size:14px;text-transform:capitalize;color:rgba(0,0,0,.5)}.input-group.input-group--selection-controls label{left:0!important;top:-3px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76b0b294","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roles/assignPermission.vue
// module id = 977
// module chunks = 0